export default __webpack_public_path__ + "static/media/_DSC0405.2c014821.JPG";